(function () {
  if (window.__oshCartDrawerInitialized) return;
  window.__oshCartDrawerInitialized = true;

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }
    callback();
  }

  ready(function () {
    var drawer = document.querySelector("[data-osh-cart-drawer]");
    var itemsRoot = document.querySelector("[data-osh-cart-items]");
    var drawerTotal = document.querySelector("[data-osh-cart-drawer-total]");
    var drawerCheckout = document.querySelector("[data-osh-cart-checkout]");
    var searchPanel = document.querySelector("[data-osh-search-panel]");
    var searchInput = document.querySelector("[data-osh-search-input]");
    var searchResults = document.querySelector("[data-osh-search-results]");
    var searchTimer;
    var lastDrawerTrigger = null;
    var lastSearchTrigger = null;
    var lastMenuTrigger = null;

    function clearNode(node) {
      while (node && node.firstChild) node.removeChild(node.firstChild);
    }

    function appendTextNode(parent, tag, text, className) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      node.textContent = text || "";
      parent.appendChild(node);
      return node;
    }

    function safeUrl(url, fallback) {
      if (!url || typeof url !== "string") return fallback || "#";
      if (/^(https?:)?\/\//.test(url) || url.charAt(0) === "/") return url;
      return fallback || "#";
    }

    function focusableElements(root) {
      if (!root) return [];
      return Array.prototype.slice.call(root.querySelectorAll([
        "a[href]",
        "button:not([disabled])",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        "[tabindex]:not([tabindex='-1'])"
      ].join(","))).filter(function (el) {
        return el.tabIndex >= 0 && (el.offsetParent !== null || el === document.activeElement);
      });
    }

    function trapFocus(event, root) {
      if (event.key !== "Tab" || !root || root.hidden) return;
      var items = focusableElements(root);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function focusFirst(root) {
      window.setTimeout(function () {
        var items = focusableElements(root);
        if (items[0]) items[0].focus();
      }, 30);
    }

    function money(cents) {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD"
      }).format((cents || 0) / 100);
    }

    function updateNav(cart) {
      document.querySelectorAll("[data-osh-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count || 0;
        el.classList.toggle("is-empty", !cart.item_count);
      });
      document.querySelectorAll("[data-osh-cart-total]").forEach(function (el) {
        el.textContent = money(cart.total_price);
        el.classList.toggle("is-empty", !cart.item_count);
      });
      if (drawerTotal) drawerTotal.textContent = money(cart.total_price);
      if (drawerCheckout) {
        var isEmpty = !cart.item_count;
        drawerCheckout.classList.toggle("is-disabled", isEmpty);
        drawerCheckout.setAttribute("aria-disabled", isEmpty ? "true" : "false");
        drawerCheckout.setAttribute("href", isEmpty ? "#" : "/checkout");
        if (isEmpty) {
          drawerCheckout.setAttribute("tabindex", "-1");
        } else {
          drawerCheckout.removeAttribute("tabindex");
        }
      }
    }

    function syncCartPage(cart) {
      var pageItems = document.querySelectorAll("[data-osh-cart-page-line]");
      if (!pageItems.length) return;

      var itemsByKey = {};
      (cart.items || []).forEach(function (item) {
        if (item.key) itemsByKey[item.key] = item;
      });

      pageItems.forEach(function (line) {
        var key = line.getAttribute("data-osh-cart-page-line");
        var item = itemsByKey[key];
        if (!item) {
          line.remove();
          return;
        }

        var input = line.querySelector("[data-osh-cart-page-qty]");
        var price = line.querySelector(".osh-cart-page__price");
        if (input && document.activeElement !== input) input.value = item.quantity || 0;
        if (price) price.textContent = money(item.final_line_price);
        line.classList.remove("is-updating");
      });

      var subtotal = document.querySelector(".osh-cart-page__summary-total strong");
      if (subtotal) subtotal.textContent = money(cart.total_price);

      if (!cart.item_count && window.location.pathname.indexOf("/cart") === 0) {
        window.location.reload();
      }
    }

    function render(cart) {
      updateNav(cart);
      syncCartPage(cart);
      if (!itemsRoot) return;
      clearNode(itemsRoot);

      if (!cart.items || !cart.items.length) {
        appendTextNode(itemsRoot, "p", "Your cart is empty.", "osh-cart-drawer__empty");
        return;
      }

      cart.items.forEach(function (item) {
        var row = document.createElement("div");
        row.className = "osh-cart-drawer__item";
        row.setAttribute("data-osh-cart-line", item.key || "");

        var imageLink = document.createElement("a");
        imageLink.className = "osh-cart-drawer__image";
        imageLink.href = safeUrl(item.url, "/cart");
        if (item.image) {
          var image = document.createElement("img");
          image.src = safeUrl(item.image, "");
          image.alt = "";
          image.width = 120;
          image.height = 120;
          imageLink.appendChild(image);
        }
        row.appendChild(imageLink);

        var detail = document.createElement("div");
        var title = document.createElement("a");
        title.className = "osh-cart-drawer__title";
        title.href = safeUrl(item.url, "/cart");
        title.textContent = item.product_title || "Product";
        detail.appendChild(title);

        if (item.variant_title && item.variant_title !== "Default Title") {
          appendTextNode(detail, "p", item.variant_title);
        }

        var line = document.createElement("div");
        line.className = "osh-cart-drawer__row";
        var qty = document.createElement("div");
        qty.className = "osh-cart-drawer__qty";
        var minus = document.createElement("button");
        minus.type = "button";
        minus.setAttribute("data-osh-drawer-qty", "-1");
        minus.setAttribute("aria-label", "Decrease quantity");
        minus.textContent = "-";
        var count = appendTextNode(qty, "span", String(item.quantity || 0));
        var plus = document.createElement("button");
        plus.type = "button";
        plus.setAttribute("data-osh-drawer-qty", "1");
        plus.setAttribute("aria-label", "Increase quantity");
        plus.textContent = "+";
        qty.appendChild(minus);
        qty.appendChild(count);
        qty.appendChild(plus);
        line.appendChild(qty);
        appendTextNode(line, "strong", money(item.final_line_price));
        detail.appendChild(line);

        var remove = document.createElement("button");
        remove.className = "osh-cart-drawer__remove";
        remove.type = "button";
        remove.setAttribute("data-osh-drawer-remove", "");
        remove.setAttribute("aria-label", "Remove item");
        remove.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16" stroke="currentColor" stroke-linecap="round"/><path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7" stroke="currentColor"/><path d="m18 7-.7 12.1A2 2 0 0 1 15.3 21H8.7a2 2 0 0 1-2-1.9L6 7" stroke="currentColor"/><path d="M10 11v6M14 11v6" stroke="currentColor" stroke-linecap="round"/></svg>';
        detail.appendChild(remove);
        row.appendChild(detail);
        itemsRoot.appendChild(row);
      });
    }

    function refresh() {
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (response) {
          if (!response.ok) throw new Error("Cart request failed");
          return response.json();
        })
        .then(function (cart) {
          render(cart);
          return cart;
        })
        .catch(function (error) {
          console.warn("OZ Smart Home cart refresh failed", error);
          if (itemsRoot) {
            clearNode(itemsRoot);
            appendTextNode(itemsRoot, "p", "Cart could not be refreshed. Please try again.", "osh-cart-drawer__empty");
          }
          return null;
        });
    }

    function clampQuantityInput(input) {
      var min = parseInt(input.getAttribute("min"), 10);
      var max = parseInt(input.getAttribute("max"), 10);
      var value = parseInt(input.value, 10);
      if (Number.isNaN(min)) min = 1;
      if (Number.isNaN(value)) value = min;
      value = Math.max(min, value);
      if (!Number.isNaN(max)) value = Math.min(max, value);
      input.value = value;
      return value;
    }

    function setFormNotice(form, message) {
      var notice = form.querySelector("[data-osh-cart-form-notice]");
      if (!notice) {
        notice = document.createElement("p");
        notice.setAttribute("data-osh-cart-form-notice", "");
        notice.className = "osh-cart-form-notice";
        form.appendChild(notice);
      }
      notice.textContent = message || "";
      notice.hidden = !message;
    }

    function updatePdpGallery(root, galleryKey, imageUrl, imageAlt) {
      if (!root) return;

      var gallery = root.querySelector("[data-osh-pdp-gallery]");
      if (!gallery) return;

      var mainImage = gallery.querySelector("[data-osh-product-main-image]");
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-osh-pdp-thumb]"));
      var visibleThumbs = [];

      thumbs.forEach(function (thumb) {
        var key = thumb.getAttribute("data-osh-gallery-key") || "";
        var visible = galleryKey ? key === galleryKey : true;
        thumb.hidden = !visible;
        thumb.classList.toggle("is-visible", visible);
        thumb.classList.remove("is-active");
        if (visible) visibleThumbs.push(thumb);
      });

      var activeThumb = visibleThumbs.find(function (thumb) {
        return imageUrl && thumb.getAttribute("data-osh-image-src") === imageUrl;
      }) || visibleThumbs[0];

      if (activeThumb) {
        activeThumb.classList.add("is-active");
        if (mainImage) {
          mainImage.src = activeThumb.getAttribute("data-osh-image-src") || imageUrl || mainImage.src;
          mainImage.alt = activeThumb.getAttribute("data-osh-image-alt") || imageAlt || mainImage.alt;
        }
      } else if (mainImage && imageUrl) {
        mainImage.src = imageUrl;
        mainImage.alt = imageAlt || mainImage.alt;
      }
    }

    function openDrawer(trigger) {
      if (!drawer) return;
      lastDrawerTrigger = trigger || document.activeElement;
      drawer.hidden = false;
      document.documentElement.classList.add("osh-cart-open");
      document.querySelectorAll("[data-osh-cart-link]").forEach(function (link) {
        link.setAttribute("aria-expanded", "true");
      });
      refresh();
      focusFirst(drawer);
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.hidden = true;
      document.documentElement.classList.remove("osh-cart-open");
      document.querySelectorAll("[data-osh-cart-link]").forEach(function (link) {
        link.setAttribute("aria-expanded", "false");
      });
      if (lastDrawerTrigger && typeof lastDrawerTrigger.focus === "function") lastDrawerTrigger.focus();
    }

    document.querySelectorAll("[data-osh-cart-link]").forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();
        openDrawer(link);
      });
    });

    document.querySelectorAll("[data-osh-cart-close]").forEach(function (button) {
      button.addEventListener("click", closeDrawer);
    });

    document.querySelectorAll("[data-osh-search-toggle]").forEach(function (button) {
      button.addEventListener("click", function () {
        if (!searchPanel) return;
        var isOpen = !searchPanel.hidden;
        lastSearchTrigger = button;
        searchPanel.hidden = isOpen;
        button.setAttribute("aria-expanded", isOpen ? "false" : "true");
        if (!isOpen && searchInput) window.setTimeout(function () { searchInput.focus(); }, 60);
        if (isOpen && lastSearchTrigger && typeof lastSearchTrigger.focus === "function") lastSearchTrigger.focus();
      });
    });

    function closeSearchPanel() {
      if (searchPanel) searchPanel.hidden = true;
      document.querySelectorAll("[data-osh-search-toggle]").forEach(function (toggle) {
        toggle.setAttribute("aria-expanded", "false");
      });
      if (lastSearchTrigger && typeof lastSearchTrigger.focus === "function") lastSearchTrigger.focus();
    }

    document.querySelectorAll("[data-osh-search-close]").forEach(function (button) {
      button.addEventListener("click", closeSearchPanel);
    });

    function renderSearchResults(items, query) {
      if (!searchResults) return;
      clearNode(searchResults);
      if (!query) {
        appendTextNode(searchResults, "p", "Start typing to preview results.");
        return;
      }
      if (!items.length) {
        appendTextNode(searchResults, "p", "No preview results. Press enter for a full search.");
        return;
      }
      items.slice(0, 6).forEach(function (item) {
        var imageUrl = typeof item.image === "string" ? item.image : item.image && item.image.url ? item.image.url : "";
        var link = document.createElement("a");
        link.className = "osh-search-result";
        link.href = safeUrl(item.url, "/search");
        var media = document.createElement("span");
        if (imageUrl) {
          var image = document.createElement("img");
          image.src = safeUrl(imageUrl, "");
          image.alt = "";
          image.width = 72;
          image.height = 72;
          media.appendChild(image);
        }
        link.appendChild(media);
        appendTextNode(link, "strong", item.title || "Result");
        appendTextNode(link, "small", item.type || "Result");
        searchResults.appendChild(link);
      });
    }

    if (searchInput) {
      searchInput.addEventListener("input", function () {
        var query = searchInput.value.trim();
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(function () {
          if (!query) {
            renderSearchResults([], "");
            return;
          }
          fetch("/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product,page,article&resources[limit]=6", {
            headers: { Accept: "application/json" }
          })
            .then(function (response) {
              if (!response.ok) throw new Error("Search failed");
              return response.json();
            })
            .then(function (data) {
              var resources = data.resources && data.resources.results ? data.resources.results : {};
              var items = []
                .concat(resources.products || [])
                .concat(resources.pages || [])
                .concat(resources.articles || [])
                .map(function (item) {
                  return {
                    title: item.title,
                    url: item.url,
                    image: item.image,
                    type: item.type || item.object_type
                  };
                });
              renderSearchResults(items, query);
            })
            .catch(function (error) {
              console.warn("OZ Smart Home search preview failed", error);
              renderSearchResults([], query);
            });
        }, 180);
      });
    }

    document.querySelectorAll("[data-osh-quantity]").forEach(function (root) {
      var input = root.querySelector("input[name='quantity']");
      if (!input) return;
      root.querySelectorAll("[data-osh-qty-minus], [data-osh-qty-plus]").forEach(function (button) {
        button.addEventListener("click", function () {
          var delta = button.hasAttribute("data-osh-qty-plus") ? 1 : -1;
          input.value = (parseInt(input.value, 10) || 1) + delta;
          clampQuantityInput(input);
        });
      });
      input.addEventListener("change", function () {
        clampQuantityInput(input);
      });
    });

    (function initProductTileFinishTooltips() {
      var tooltip;
      var activeControl;

      function ensureTooltip() {
        if (tooltip) return tooltip;
        tooltip = document.createElement("div");
        tooltip.className = "osh-finish-tooltip";
        tooltip.setAttribute("role", "tooltip");
        tooltip.hidden = true;
        document.body.appendChild(tooltip);
        return tooltip;
      }

      function positionTooltip(control) {
        if (!tooltip || !control) return;
        var rect = control.getBoundingClientRect();
        var tooltipRect = tooltip.getBoundingClientRect();
        var gap = 9;
        var left = rect.left + rect.width / 2 - tooltipRect.width / 2;
        left = Math.max(10, Math.min(left, window.innerWidth - tooltipRect.width - 10));
        var top = rect.top - tooltipRect.height - gap;
        if (top < 10) top = rect.bottom + gap;
        tooltip.style.left = left + "px";
        tooltip.style.top = top + "px";
      }

      function showTooltip(control) {
        var label = control && control.getAttribute("data-osh-finish-tooltip");
        if (!label) return;
        activeControl = control;
        ensureTooltip();
        tooltip.textContent = label;
        tooltip.hidden = false;
        window.requestAnimationFrame(function () {
          positionTooltip(control);
        });
      }

      function hideTooltip(control) {
        if (control && activeControl && control !== activeControl) return;
        activeControl = null;
        if (tooltip) tooltip.hidden = true;
      }

      document.addEventListener("mouseover", function (event) {
        var control = event.target.closest(".osh-product-card [data-osh-finish-tooltip]");
        if (!control) return;
        showTooltip(control);
      });

      document.addEventListener("mouseout", function (event) {
        var control = event.target.closest(".osh-product-card [data-osh-finish-tooltip]");
        if (!control) return;
        if (event.relatedTarget && control.contains(event.relatedTarget)) return;
        hideTooltip(control);
      });

      document.addEventListener("focusin", function (event) {
        var control = event.target.closest(".osh-product-card [data-osh-finish-tooltip]");
        if (control) showTooltip(control);
      });

      document.addEventListener("focusout", function (event) {
        var control = event.target.closest(".osh-product-card [data-osh-finish-tooltip]");
        if (control) hideTooltip(control);
      });

      window.addEventListener("scroll", function () {
        if (activeControl) positionTooltip(activeControl);
      }, { passive: true });

      window.addEventListener("resize", function () {
        if (activeControl) positionTooltip(activeControl);
      });
    })();

    document.querySelectorAll("[data-osh-finish-picker]").forEach(function (picker) {
      var form = picker.closest("form");
      var card = picker.closest(".osh-product-card");
      var main = picker.closest(".osh-page__grid");

      function applyVariant(control) {
        if (!control || control.disabled) return;

        var id = control.getAttribute("data-osh-variant-id") || control.value;
        var title = control.getAttribute("data-osh-variant-title") || "";
        var imageUrl = control.getAttribute("data-osh-variant-image") || "";
        var imageAlt = control.getAttribute("data-osh-variant-image-alt") || title;
        var galleryKey = control.getAttribute("data-osh-variant-gallery-key") || "";
        var available = control.getAttribute("data-osh-variant-available") !== "false";
        var hidden = form ? form.querySelector("[data-osh-selected-variant]") : null;
        var quantityInput = form ? form.querySelector("input[name='quantity']") : null;
        var submit = form ? form.querySelector("[type='submit']") : null;
        var labelRoot = form || picker;
        var label = labelRoot.querySelector("[data-osh-selected-variant-label]");
        var image = card ? card.querySelector("[data-osh-product-card-image]") : main ? main.querySelector("[data-osh-product-main-image]") : null;

        if (hidden) hidden.value = id;
        if (quantityInput) {
          quantityInput.removeAttribute("max");
          quantityInput.setAttribute("aria-label", "Quantity for " + title);
          clampQuantityInput(quantityInput);
        }
        if (submit) {
          submit.disabled = !available;
          submit.textContent = !available ? "Sold out" : submit.getAttribute("data-osh-add-label") || submit.textContent;
        }
        if (form) setFormNotice(form, "");
        if (label && title) label.textContent = title;
        if (image && imageUrl) {
          image.src = imageUrl;
          image.alt = imageAlt;
        }
        updatePdpGallery(main, galleryKey, imageUrl, imageAlt);

        picker.querySelectorAll("[data-osh-variant-id]").forEach(function (option) {
          var active = option.getAttribute("data-osh-variant-id") === id;
          option.classList.toggle("is-active", active);
          option.setAttribute("aria-pressed", active ? "true" : "false");
        });
      }

      picker.addEventListener("click", function (event) {
        var button = event.target.closest("button[data-osh-variant-id]");
        if (!button) return;
        applyVariant(button);
      });

      picker.addEventListener("change", function (event) {
        var input = event.target.closest("input[data-osh-variant-id]");
        if (!input) return;
        applyVariant(input);
      });
    });

    document.querySelectorAll("[data-osh-pdp-gallery]").forEach(function (gallery) {
      var mainImage = gallery.querySelector("[data-osh-product-main-image]");

      function visibleThumbs() {
        return Array.prototype.slice.call(gallery.querySelectorAll("[data-osh-pdp-thumb]")).filter(function (thumb) {
          return !thumb.hidden;
        });
      }

      function setActiveThumb(thumb) {
        if (!thumb || !mainImage) return;
        visibleThumbs().forEach(function (item) {
          item.classList.toggle("is-active", item === thumb);
        });
        mainImage.src = thumb.getAttribute("data-osh-image-src") || mainImage.src;
        mainImage.alt = thumb.getAttribute("data-osh-image-alt") || mainImage.alt;
      }

      gallery.querySelectorAll("[data-osh-pdp-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          setActiveThumb(thumb);
        });
      });

      gallery.querySelectorAll("[data-osh-pdp-prev], [data-osh-pdp-next]").forEach(function (button) {
        button.addEventListener("click", function () {
          var thumbs = visibleThumbs();
          if (thumbs.length < 2) return;
          var activeIndex = thumbs.findIndex(function (thumb) {
            return thumb.classList.contains("is-active");
          });
          if (activeIndex < 0) activeIndex = 0;
          var direction = button.hasAttribute("data-osh-pdp-prev") ? -1 : 1;
          setActiveThumb(thumbs[(activeIndex + direction + thumbs.length) % thumbs.length]);
        });
      });
    });

    document.querySelectorAll("form[data-osh-cart-form]").forEach(function (form) {
      var submit = form.querySelector("[type='submit']");
      if (submit && !submit.getAttribute("data-osh-add-label")) {
        submit.setAttribute("data-osh-add-label", submit.textContent);
      }

      form.addEventListener("submit", function (event) {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        var submit = form.querySelector("[type='submit']");
        var label = submit ? submit.textContent : "";
        var quantityInput = form.querySelector("input[name='quantity']");
        if (quantityInput) clampQuantityInput(quantityInput);

        setFormNotice(form, "");
        if (submit) {
          submit.disabled = true;
          submit.textContent = "Adding...";
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().catch(function () {
                throw new Error("Add to cart failed");
              }).then(function (data) {
                throw new Error(data.description || data.message || "Add to cart failed");
              });
            }
            return response.json();
          })
          .then(function () {
            return refresh();
          })
          .then(function () {
            openDrawer(submit);
          })
          .catch(function (error) {
            setFormNotice(form, error.message || "Could not add that quantity.");
          })
          .finally(function () {
            if (submit) {
              submit.disabled = false;
              submit.textContent = label;
            }
          });
      });
    });

    if (itemsRoot) {
      itemsRoot.addEventListener("click", function (event) {
        var button = event.target.closest("[data-osh-drawer-qty]");
        var remove = event.target.closest("[data-osh-drawer-remove]");
        var line = event.target.closest("[data-osh-cart-line]");
        if ((!button && !remove) || !line) return;
        var current = parseInt(line.querySelector(".osh-cart-drawer__qty span").textContent, 10) || 0;
        var quantity = remove ? 0 : Math.max(0, current + (parseInt(button.getAttribute("data-osh-drawer-qty"), 10) || 0));
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: line.getAttribute("data-osh-cart-line"), quantity: quantity })
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Cart change failed");
            return response.json();
          })
          .then(render)
          .catch(function (error) {
            console.warn("OZ Smart Home cart update failed", error);
            if (itemsRoot) {
              clearNode(itemsRoot);
              appendTextNode(itemsRoot, "p", "Cart could not be updated. Please try again.", "osh-cart-drawer__empty");
            }
          });
      });
    }

    if (drawerCheckout) {
      drawerCheckout.addEventListener("click", function (event) {
        if (drawerCheckout.classList.contains("is-disabled")) {
          event.preventDefault();
        }
      });
    }

    function changeCartLine(id, quantity) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: id, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Cart change failed");
          return response.json();
        });
    }

    document.querySelectorAll("[data-osh-cart-page-line]").forEach(function (line) {
      var input = line.querySelector("[data-osh-cart-page-qty]");
      var remove = line.querySelector("[data-osh-cart-page-remove]");
      var key = line.getAttribute("data-osh-cart-page-line");
      var pending;

      function apply(quantity) {
        window.clearTimeout(pending);
        line.classList.add("is-updating");
        pending = window.setTimeout(function () {
          changeCartLine(key, Math.max(0, quantity))
            .then(function () {
              window.location.reload();
            })
            .catch(function (error) {
              console.warn("OZ Smart Home cart page update failed", error);
              line.classList.remove("is-updating");
            });
        }, 120);
      }

      if (input) {
        input.addEventListener("input", function () {
          if (input.value === "") return;
          apply(parseInt(input.value, 10) || 0);
        });

        input.addEventListener("change", function () {
          apply(parseInt(input.value, 10) || 0);
        });
      }

      line.querySelectorAll("[data-osh-cart-page-qty-minus], [data-osh-cart-page-qty-plus]").forEach(function (button) {
        button.addEventListener("click", function () {
          if (!input) return;
          var delta = button.hasAttribute("data-osh-cart-page-qty-plus") ? 1 : -1;
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
          input.value = next;
          apply(next);
        });
      });

      if (remove) {
        remove.addEventListener("click", function (event) {
          event.preventDefault();
          apply(0);
        });
      }
    });

    document.addEventListener("change", function (event) {
      if (event.target.closest("cart-items") || event.target.closest(".cart")) {
        window.setTimeout(refresh, 700);
      }
    });
    document.addEventListener("click", function (event) {
      if (event.target.closest("cart-items") || event.target.closest(".cart")) {
        window.setTimeout(refresh, 700);
      }
    });

    document.addEventListener("keydown", function (event) {
      trapFocus(event, drawer);
      trapFocus(event, searchPanel);
      if (event.key === "Escape") {
        closeDrawer();
        closeSearchPanel();
      }
    });

    refresh();
  });
})();
